import { useState } from "react";
import HeaderComponent from "components/card/HeaderComponent";
import { Calendar } from "antd";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import IndexModal from "components/modal";
import DailyAttendances from "./DailyAttendances";
import dayjs from "dayjs";


const CalendarView = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedDay, setSelectedDay] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(null);

  const onPanelChange = (value, mode) => {
    setCurrentMonth(value.clone().startOf("month"));
  };

  const isSameMonth = (a, b) => {
    return a.format("YYYY-MM") === b.format("YYYY-MM");
  };

  return (
    <HeaderComponent
      title="Calendar View"
      description="Click on a date to view detailed attendance"
    >
      <div className="flex justify-center items-center p-4 mx-4 border rounded-xl h-[330px] overflow-hidden">
        <Calendar
          fullscreen={false}
          onPanelChange={onPanelChange}
          onSelect={(value) => {
            if (currentMonth && !isSameMonth(value.clone().startOf("month"), currentMonth)) {
              return;
            }
            setSelectedDay(value);
            setIsOpen(true);
          }}
          disabledDate={(current) => {
            return current && current.isAfter(dayjs(), "day");
          }}
          headerRender={({ value, onChange }) => {
            const current = value.clone();

            if (!currentMonth) {
              setCurrentMonth(current.clone().startOf("month"));
            }

            const goPrev = () => {
              const newVal = current.clone().subtract(1, "month");
              onChange(newVal);
              onPanelChange(newVal, "month");
            };

            const goNext = () => {
              const newVal = current.clone().add(1, "month");
              onChange(newVal);
              onPanelChange(newVal, "month");
            };

            return (
              <div className="flex items-center justify-between mb-4 px-2 select-none">
                <button
                  onClick={goPrev}
                  className="p-2 rounded-lg hover:bg-slate-100 transition"
                >
                  <FaChevronLeft />
                </button>

                <div className="font-medium">{current.format("MMMM YYYY")}</div>

                <button
                  onClick={goNext}
                  className="p-2 rounded-lg hover:bg-slate-100 transition"
                >
                  <FaChevronRight />
                </button>
              </div>
            );
          }}
        />

        <IndexModal
          open={isOpen}
          onClose={() => setIsOpen(false)}
          useCustomClass={true}
          maxContentHeight="85vh"
          width="sm:max-w-xl max-w-2xl"
        >
          <DailyAttendances selectedDay={selectedDay} />
        </IndexModal>
      </div>
    </HeaderComponent>
  );
};

export default CalendarView;
